// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: the relocation panel's destination server search (relocation-plan.md §21). The query is trimmed and
// lower-cased, then matched anywhere in the server's name, as the destination channel search does; Obyrus matches
// the same way. The shared Combobox default (no trim) is left as upstream has it. Exclude from upstream sync.

export function relocationServerMatches(label: string, query: string): boolean {
	const needle = query.trim().toLowerCase();
	if (!needle) return true;
	return label.toLowerCase().includes(needle);
}
